export const isPlaceholderEmail = (email: string) => /@hasnotsetemail.meetdandy.com$/.test(email);
